import { TmsEventType, } from '../DataLayer.types';
import DataLayerBaseEvent from './DataLayerBaseEvent';
export default class PaginationClickEvent extends DataLayerBaseEvent {
    update(tms, payload, errorHandler) {
        this.updateDataLayer(tms, TmsEventType.view, 'vpv-search result', {
            page_number: payload.pageNumber.toString(),
        }, errorHandler);
    }
}
//# sourceMappingURL=PaginationClickEvent.js.map